import { findKey } from 'lodash';
import momentUtc from '@/utils/momentUtc';
import {
    UPLOAD_STATUS_WAITING,
    UPLOAD_STATUS_INITIALIZING,
    UPLOAD_STATUS_UPLOADING,
    UPLOAD_STATUS_UPLOADED,
} from '@/utils/config/episodeOptions';

export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const statusConfigs = {
    published: {
        compare: (value) => momentUtc.parse(value).isSameOrBefore(momentUtc.now()),
        value: () => momentUtc.now().format(dateTimeFormat),
        optionConfig: {
            icon: 'history',
            label: [
                {
                    context: 'create',
                    uploadStatus: [UPLOAD_STATUS_WAITING, UPLOAD_STATUS_INITIALIZING, UPLOAD_STATUS_UPLOADING, UPLOAD_STATUS_UPLOADED],
                    value: 'Go live after processing is complete',
                },
                { context: 'create', uploadStatus: null, value: 'Go live immediately' },
                { context: 'edit', value: 'Go live immediately' },
            ],
        },
        buttonConfig: {
            class: 'is-green',
            label: {
                create: 'Publish Episode',
                edit: 'Save Episode Changes',
            },
        },
    },
    unpublished: {
        compare: (value) => null === value,
        value: () => null,
        optionConfig: {
            icon: 'pen',
            label: [
                { context: 'create', value: 'Leave unpublished' },
                { context: 'edit', value: 'Leave unpublished' },
            ],
        },
        buttonConfig: {
            label: {
                create: 'Save Episode Details',
                edit: 'Save Episode Details',
            },
        },
    },
    scheduled: {
        disabled: false,
        compare: (value) => momentUtc.parse(value).isAfter(momentUtc.now()),
        optionConfig: {
            icon: 'calendar-alt',
            label: [
                { context: 'create', value: 'Schedule for future' },
                { context: 'edit', value: 'Schedule for future' },
            ],
        },
        buttonConfig: {
            class: 'is-green',
            label: {
                create: 'Schedule Episode',
                edit: 'Save & Schedule Episode',
            },
        },
    },
};

/**
 * Converts publication date to episode status.
 *
 * @param    {string|null}  publishedAt  Publication date.
 * @returns  {string}                    Episode status.
 */
export const publicationDateToEpisodeStatus = (publishedAt) => {
    return findKey(statusConfigs, (config) => config.compare(publishedAt));
};
